import { SET_CURRENTCASE_ACCESS } from "redux/types";

const setCurrentCaseAccess = (payload) => {
    return { type: SET_CURRENTCASE_ACCESS, payload };
};

export { setCurrentCaseAccess };
